import auth from "@/core/middlewares/auth";
import permissions from "@/core/middlewares/permissions";
import mobile from "@/core/middlewares/mobile";

export default [
    auth,
]